import React, {useContext, useEffect} from 'react';
import {Formik} from 'formik';
import * as Yup from 'yup';
import {
  TextField,
  FormHelperText,
  Button,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from '@material-ui/core';
import {ThemeContext} from '../../../themes/ThemeProvider';
import {useDispatch, useSelector} from 'react-redux';
import {
  postContactsData,
  postPhonesData,
  resetToast,
} from '../../../redux/reducers/clientMangement/Organizaation';
import GuiTextField from '../../../components/FormComponents/GuiTextField';
import GuiAutoComplete from '../../../components/FormComponents/GuiAutoComplete';
import {PhoneMaskCustom} from '../../../util/PhoneMaskFormat';
import formatPhoneNumber from '../../../util/PhoneFormat';
import {submissionStart} from '../../../redux/reducers/CommonActions/commonActions';
const CompanyForm = ({id, type, selectedRows}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();

  const {
    successMsg,
    errorMsg,
    dropDownData,
    editContactPhoneData,
    editContactData,
  } = useSelector(({organization}) => organization);
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  useEffect(() => {
    if (successMsg || errorMsg) {
      setTimeout(() => {
        dispatch(resetToast());
      }, 3000);
    }
  }, [successMsg, errorMsg]);

  const validationSchema = Yup.object().shape({
    phoneNumber: Yup.string()
      .test('phone', 'Invalid Phone Number', (value) => {
        value = value && value.replace(/[^\d]/g, '');
        if ((value && /^(\d)(?!\1+$)\d{9}$/.test(value)) || !value) {
          return true;
        }
      })
      .required('Phone Number is required'),
    phoneType: Yup.mixed()
      .test('phoneType', 'Phone Type is required', (value) => {
        if (!value?.value) {
          return false;
        } else {
          return true;
        }
      })
      .required('Phone Type is required'),
  });
  const getOption = (data, property, value) => {
    if (!data || data?.length === 0) {
      return {};
    }
    const obj = data?.find((item) => item[property] === value);
    return obj ? obj : {};
  };

  const initialVal = {
    phoneType:
      getOption(
        dropDownData?.CLIENT_PHONE_TYPE,
        'value',
        editContactPhoneData?.phoneType || editContactData?.phoneType,
      ) || {},
    optInFlag: editContactPhoneData?.optInFlag || editContactData?.optInFlag || '',
    orgId: 0,
    orgPhoneId: 0,
    orgType: '',
    phoneNumber:
      formatPhoneNumber(editContactPhoneData?.phoneNumber || editContactData?.phoneNumber) || '',
    seqNo: 0,
  };

  const handleSubmit = (values) => {
    if (values) {
      dispatch(submissionStart());
      const data = {
        optInFlag: values?.optInFlag || 'Yes',
        phoneNumber: values?.phoneNumber || '',
        phoneType: values?.phoneType?.value || '',
        orgPhoneId: editContactPhoneData?.orgPhoneId || 0,
        orgId: id,
        orgType: type || '',
        seqNo: editContactPhoneData?.seqNo ?
          editContactPhoneData?.seqNo :
          Array.isArray(selectedRows) ?
            selectedRows?.length + 1 :
            1,
      };
      dispatch(postPhonesData(data));
    } else if (values) {
      dispatch(submissionStart());
      const data = {
        optInFlag: values?.optInFlag || 'Yes',
        phoneNumber: values?.phoneNumber || '',
        phoneType: values?.phoneType?.value || '',
        organizationContactId: editContactData?.organizationContactId || 0,
        orgId: id,
        orgType: type || '',
      };
      dispatch(postContactsData(data));
    }
  };

  return (
    <>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialVal}
        validationSchema={validationSchema}
        enableReinitialize
      >
        {(props) => {
          const {
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue,
            resetForm,
          } = props;
          return (
            <div className={classes.dialoguecardStyles}>
              <form autoComplete="off" noValidate onSubmit={handleSubmit}>
                <div className="form-row global-field-textfields  new-standard-textfields">
                  <div className="col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group">
                    <TextField
                      className={`${classes.labelName}`}
                      margin="dense"
                      variant="outlined"
                      placeholder={`Enter Phone Number`}
                      label="Phone Number"
                      // InputLabelProps={{
                      //   shrink: true,
                      // }}
                      disabled={editContactData}
                      name="phoneNumber"
                      required={!editContactData}
                      value={values?.phoneNumber}
                      onChange={(e) => {
                        handleChange(e);
                        setFieldValue('phoneNumber', e.target.value);
                      }}
                      onBlur={handleBlur}
                      InputProps={{
                        inputComponent: PhoneMaskCustom,
                      }}
                      fullWidth
                      touched={touched.phoneNumber}
                      error={Boolean(touched.phoneNumber && errors.phoneNumber)}
                    />
                    <FormHelperText>
                      {touched.phoneNumber && errors?.phoneNumber && errors.phoneNumber}
                    </FormHelperText>
                  </div>
                  <div className="col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group">
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      id="phoneType"
                      options={dropDownData?.CLIENT_PHONE_TYPE || []}
                      size="small"
                      value={values.phoneType}
                      disabled={editContactData}
                      autoHighlight
                      getOptionLabel={(option) => {
                        return option && option.valueCode && option.value ?
                          option.valueCode + ' - ' + option.value :
                          option.value === null ?
                            option.valueCode :
                            '';
                      }}
                      renderInput={(params) => (
                        <GuiTextField
                          className={`errorcontent ${classes.labelName}`}
                          {...params}
                          variant="outlined"
                          fullWidth
                          label="Phone Type"
                          name="phoneType"
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          placeholder="Select Phone Type"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: 'off',
                          }}
                          required={!editContactData}
                          touched={touched.phoneType}
                          error={touched.phoneType && errors.phoneType}
                        />
                      )}
                      onChange={(_, data) => {
                        setFieldValue('phoneType', data);
                      }}
                    />
                    <FormHelperText style={{color: 'red'}}>
                      {touched.phoneType && errors?.phoneType && errors.phoneType}
                    </FormHelperText>
                  </div>
                  <div className={`col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group ${classes.selectField}`}>
                    <FormControl
                      // margin="dense"
                      variant="outlined"
                      fullWidth
                    >
                      <InputLabel id="demo-simple-select-label">Opt In</InputLabel>
                      <Select
                        id="demo-simple-select"
                        className={`${classes.labelName}`}
                        labelId="demo-simple-select-label"
                        fullWidth
                        name="optInFlag"
                        disabled={editContactData}
                        label="Opt In"
                        value={values.optInFlag || 'Yes'}
                        onChange={(e) => {
                          setFieldValue('optInFlag', e.target.value);
                        }}
                      >
                        {['Yes', 'No'].map((option) => {
                          return (
                            <MenuItem value={option} key={option}>
                              {option}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </div>
                </div>
                {!editContactData && (
                  <div className="d-flex justify-content-center align-items-center new-standard-textfields">
                    <Button
                      variant="outlined"
                      className={`reset-btn mr-1 ${classes.buttonRoot}`}
                      onClick={() => {
                        resetForm();
                      }}
                    >
                      Reset
                    </Button>
                    <Button
                      variant="outlined"
                      type="submit"
                      className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
                      disabled={enabledSubmission}
                    >
                      Save
                    </Button>
                  </div>
                )}
              </form>
            </div>
          );
        }}
      </Formik>
    </>
  );
};

export default CompanyForm;
